import { no } from './no';

export const messages = {
  no,
};
